export function parseBoolean(value: boolean | number | string | undefined, defaultValue: boolean): boolean {
    if (typeof value === 'boolean') {
        return value;
    } else if (typeof value === 'number') {
        return !!value;
    } else if (typeof value === 'string') {
        const newValue = value.trim().toLowerCase();
        if (newValue === 'false') {
            return false;
        } else if (newValue === 'true') {
            return true;
        }
    }

    return defaultValue;
}
